module.exports = __webpack_public_path__ + "static/media/04_tearsofhair.c67e91f3.jpg";